export default __webpack_public_path__ + "static/media/hotel_lobby.0f65f7cf.jpeg";